// extracted by mini-css-extract-plugin
export default {"certificate-tasks-table":"CertificateTasksTable_certificate-tasks-table__VoE2f","company-bpn":"CertificateTasksTable_company-bpn__KKUnd"};